import React from 'react';
import { I_TodayMoreGroup } from '@Redux/detail/Group/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import DirectionList from './DirectionList';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { useTranslation } from 'react-i18next';

interface I_Props {
    GroupList: I_TodayMoreGroup[];
}

function GroupList({ GroupList }: I_Props) {
    const { t } = useTranslation();
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    return (
        <ul className={styles.groupList}>
            {GroupList?.map((group: I_TodayMoreGroup, i: number) => (
                <li key={i} className={cN(styles.group, [isPrint ? 'flight-group' : ''])}>
                    {!isPrint && (
                        <div className={styles.basics}>
                            <div className={styles.groupID}>
                                {t('GroupID')}：{group.GroupID}
                            </div>
                        </div>
                    )}
                    {Array.isArray(group.DirectionList) && group.DirectionList.length > 0 && (
                        <div className={styles.flights}>
                            <DirectionList directions={group.DirectionList} />
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
}

export default GroupList;
